'use client';

export { default } from './Tab';
export * from './tabClasses';
export { default as tabClasses } from './tabClasses';
export * from './TabProps';